import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import StyledRevealBox from './RevealBox.style.js';

const RevealBox = (_ref) => {
  let {
    as,
    children,
    className,
    isVisible,
    direction
  } = _ref,
      props = _objectWithoutProperties(_ref, ["as", "children", "className", "isVisible", "direction"]);

  return /*#__PURE__*/React$1.createElement(StyledRevealBox, _extends({
    as: as,
    className: className,
    isVisible: isVisible,
    direction: direction
  }, props), children);
};

RevealBox.propTypes = {
  as: PropTypes$1.string,
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  isVisible: PropTypes$1.bool,
  direction: PropTypes$1.oneOf(['left', 'right'])
};
RevealBox.defaultProps = {
  as: null,
  children: null,
  isVisible: true,
  className: null,
  direction: 'right'
};

export default RevealBox;
